// Typelizer digest bb103b2b4e5c60874e4439c9b61071ee
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** PATCH /c/:company_id/counterparties/:counterparty_id/role */
  update: (
    params: { counterpartyId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/counterparties/:counterparty_id/role', params, options),
    method: 'patch',
  }),
}
